import { axiosServices } from "./axiosServices";

export const lrServices = { getLRListing, getLRProductList, getLRDocumentsList, createLR, updateLR };

function getLRListing(param) {
    return axiosServices.getAxios(`/v1/common/lorry-receipts${param}`).then((res) => {
        return res;
    });
}

function getLRProductList(lrId, param) {
    return axiosServices.getAxios(`/v1/common/lorry-receipts/${lrId}/products${param}`).then((res) => {
        return res;
    });
}

function getLRDocumentsList(lrId, param) {
    return axiosServices.getAxios(`/v1/common/lorry-receipts/documents`).then((res) => {
        return res;
    });
}


function createLR(bodyData) {
    return axiosServices
        .postAxios("/v1/common/lorry-receipts", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateLR(param, bodyData) {
    return axiosServices
        .putAxios(`/v1/common/lorry-receipts/${param}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}
